var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-0.000100, 0.000000)",
    fill: "#DDDAD4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9999,0 L17.9999,1.414 L12.5359,6.878 C11.3659,8.048 11.3659,9.951 12.5359,11.121 L12.5359,11.121 L17.9999,16.586 L17.9999,18 L16.5859,18 L11.1219,12.535 C9.1719,10.586 9.1719,7.414 11.1219,5.464 L11.1219,5.464 L16.5859,0 L17.9999,0 Z M1.414,0 L6.879,5.464 C8.829,7.414 8.829,10.586 6.879,12.535 L6.879,12.535 L1.414,18 L0,18 L0,16.586 L5.465,11.121 C6.634,9.951 6.634,8.048 5.465,6.878 L5.465,6.878 L0,1.414 L0,0 L1.414,0 Z",
    id: "icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close-gray.f160e61826a14cbe8ee0e4a10cdf2885.svg";
export { ForwardRef as ReactComponent };